import useRouteQuery from './useRouterQuery';

export const useTabQueryGroup = (prefix: string) => {
  const [name, setName] = useRouteQuery('', `${prefix}_name`, String);
  const [username, setUsername] = useRouteQuery('', `${prefix}_username`, String);
  const [email, setEmail] = useRouteQuery('', `${prefix}_email`, String);
  const [companyName, setCompanyName] = useRouteQuery('', `${prefix}_companyName`, String);
  const [usdot, setUsdot] = useRouteQuery('', `${prefix}_usdot`, String);
  const [uid, setUid] = useRouteQuery('', `${prefix}_uid`, String);
  const [ownerName, setOwnerName] = useRouteQuery('', `${prefix}_ownerName`, String);
  const [ownerId, setOwnerId] = useRouteQuery('', `${prefix}_ownerId`, String);
  const [skip, setSkip] = useRouteQuery('1', `${prefix}_skip`, String);

  return {
    name,
    setName,
    username,
    setUsername,
    email,
    setEmail,
    companyName,
    setCompanyName,
    usdot,
    setUsdot,
    uid,
    setUid,
    ownerName,
    setOwnerName,
    ownerId,
    setOwnerId,
    skip,
    setSkip,
  };
};
